import React from 'react';

// Accessible "Skip to content" link for keyboard users
const SkipLink = () => (
  <a
    href="#main"
    className="sr-only focus:not-sr-only fixed top-2 left-2 z-[100] bg-deep-indigo text-white text-sm px-3 py-2 rounded-md shadow-md focus:outline-none focus:ring-2 focus:ring-white/50"
  >
    Skip to main content
  </a>
);

export default SkipLink;